<script lang="ts">
    import Line from "./Line.svelte";
    import TilePartner from "./TilePartner.svelte";
    import {storePartners} from "../scripts/ecosystem";
    import { onMount } from "svelte";
    import {redirectTo, storeCurRoute} from "../scripts/router1";
    import {idPageDevenirPartenaire, idPageNosPartenaires} from "../scripts/router2";
    import type {EcosystemInterface} from "../scripts/ecosystem";
    import { storeLanguage, lang_fr } from "../scripts/store";

    let partners: EcosystemInterface[] = [];
    let partnersDyn: EcosystemInterface[] = [];

    onMount(async() => {
        storePartners.subscribe((data) => {
            partners = [];
            data.forEach(item => {
                const tile: EcosystemInterface = item;
                partners.push(tile);
            });
            partnersDyn = partners;
        })
    })

</script>
    
<style lang="scss">

    .homepartenaires {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        background-image: url("../assets/images/Collectif-1920-1080-px-4.png");
        background-size: cover;
        background-repeat: no-repeat;
        background-position: left top;
        padding: 0 0 80px 0;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__title {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            color: $color_orange;
            padding: 50px 0 30px 0;
            text-transform: uppercase;
        }
        &__subtitle {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            color: $color_white;
        }
        &__text {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            color: $color_white;
            width: 85%;
            text-align: center;
        }
        &__tiles {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            margin: 60px 32px 60px 32px;
        }
    }

    @include large {
        .homepartenaires {
            &__tiles {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;
            }
        }
    }

</style>

<div class="homepartenaires">
    <div class="bloc homepartenaires__bloc">
        <div class="homepartenaires__title font__h4">
            {#if ($storeLanguage == $lang_fr)}
            Seul on va vite, ensemble on va plus loin
            {:else}
            Alone we go fast, together we go further
            {/if}
        </div>
        {#if ($storeCurRoute != idPageNosPartenaires)}
        <div class="homepartenaires__subtitle font__h2">
            {#if ($storeLanguage == $lang_fr)}
            Nos partenaires
            {:else}
            Our partners
            {/if}
        </div>
        {/if}
        <Line />
        <div class="homepartenaires__text">
            {#if ($storeLanguage == $lang_fr)}
            Être partenaire du Collectif API Thinking, c’est être partenaire du 1er collectif français dédié aux APIs. Il vous permettra de rayonner au plus près de votre écosystème, de communiquer à nos membres votre expertise, vos produits et de rencontrer de nouveaux partenaires, clients, mais aussi de faire (re)connaître votre marque.
            {:else}
            Being a partner of the API Thinking Collective means being a partner of the 1st French collective dedicated to APIs. It will allow you to shine as close as possible to your ecosystem, to communicate to our members your expertise, your products and to meet new partners, customers, but also to make your brand (re)known.
            {/if}
        </div>
        <div class="homepartenaires__tiles">
            {#each partnersDyn as partner }
                <TilePartner props={partner}/>    
            {/each}
        </div>
        <div on:click={() => redirectTo(idPageDevenirPartenaire)} on:keydown={() => redirectTo(idPageDevenirPartenaire)}>
        <div class="buttonWhite">
            {#if ($storeLanguage == $lang_fr)}
            Devenir partenaire
            {:else}
            Become a partner
            {/if}
        </div>
        </div>
    </div>
</div>
